(function () {
  'use strict';

  [
      'Activity',
      'Region'
  ].forEach(createDirective);

  angular
      .module('tfc.retailer.ActivityRegionFilter')
      .directive('tfcActivityRegionFilter', tfcActivityRegionFilter)
      .controller('ActivityFilterCtrl', ActivityFilterCtrl)
      .controller('RegionFilterCtrl', RegionFilterCtrl);


  function ActivityFilterCtrl(){
    var vm = this;
    vm.selectedActivity = vm.filters && vm.filters.getSelected();
    vm.activityChangeEvent = function () {
      if(vm.selectedActivity) {
        vm.filters.setSelected(vm.selectedActivity.label);
        vm.filterFunc({activity: vm.selectedActivity});
      } else {
        vm.selectedActivity = vm.filters && vm.filters.getSelected();
      }
    }
  }

  function RegionFilterCtrl() {
    var vm = this;
    vm.selectedRegion = vm.filters && vm.filters.getSelectedRegion();
    vm.regionChangeEvent = function () {
      if(vm.selectedRegion){
        vm.filters.setSelectedRegion(vm.selectedRegion.label);
        vm.filterFunc({region: vm.selectedRegion});
      } else {
        vm.selectedRegion = vm.filters && vm.filters.getSelectedRegion();
      }
    }
  }

  function tfcActivityRegionFilter(){
    return {
      restrict: 'E',
      templateUrl : 'Util/ActivityRegionFilter/ActivityRegionFilter.tmpl.html',
      scope: true
    }
  }

  function createDirective(type) {
    var name = 'tfc' + type + 'Filter';
    angular
        .module('tfc.retailer.ActivityRegionFilter')
        .directive(name, directiveFn);

    // @ngInject
    function directiveFn() {
      return {
        scope : {
          filters : '=',
          filterFunc : '&'
        },
        controller : type + 'FilterCtrl as vm',
        bindToController : true,
        templateUrl : 'Util/ActivityRegionFilter/' + type + 'Filter.tmpl.html'
      };
    }
  }

})();